export default {
    ACCEPTED_TRADE: 'Du hast den Handel akzeptiert.',
    ACCEPTED_TRADE_OTHER: 'Der andere Spieler hat den Handel akzeptiert.',
    ALREADY_HAVE_PET: 'Du hast bereits ein Haustier.',
    BLACK_POTION: 'Du trinkst den schwarzen Trank und fühlst dich unwohl.',
    CANNOT_ADD_ITEMS_TRADE: 'Du kannst keine weiteren Gegenstände zum Handel hinzufügen.',
    CANNOT_ATTACK_CHEATER:
        'Dieser Spieler ist ein Betrüger. Du solltest so jemanden nicht angreifen.',
    CANNOT_ATTACK_CHEATER_SELF:
        'Sorry, aber Betrüger können andere Spieler nicht angreifen, das wäre ihnen gegenüber nicht fair!',
    CANNOT_ATTACK_MOB: 'Du hast keinen Grund, diese Kreaturen anzugreifen.',
    CANNOT_ATTACK_PET:
        'Du bist verrückt? Du hast den Verstand verloren? Warum solltest du ein Haustier angreifen?',
    CANNOT_ATTACK_PREY: 'Du kannst nicht angreifen, wenn du die Beute bist.',
    CANNOT_ATTACK_TARGET: 'Du kannst niemanden angreifen, der nicht dein Ziel ist.',
    CANNOT_ATTACK_LEVEL_DIFF:
        'Du kannst niemanden angreifen, der mehr als 30 Levels über oder unter dir ist.',
    CANNOT_DO_THAT: 'Du kannst das im Moment nicht tun.',
    CANNOT_DROP_ITEM_DOOR:
        'Du kannst diesen Gegenstand nicht fallen lassen, wenn du in einer Tür stehst.',
    CANNOT_PASS_DOOR: 'Du kannst nicht durch diese Tür gehen.',
    CANNOT_GLOBAL_CHAT_SECONDS:
        'Du musst weitere {{duration}} Sekunden warten, bevor du den globalen Chat benutzen kannst.',
    CANNOT_GLOBAL_CHAT_MINUTES:
        'Du musst weitere {{duration}} Minuten warten, bevor du den globalen Chat benutzen kannst.',
    CANNOT_GLOBAL_CHAT_JAIL:
        'Du kannst den globalen Chat nicht benutzen, solange du inhaftiert bist.',
    CANNOT_GLOBAL_CHAT_TUTORIAL:
        'Du kannst den globalen Chat nicht benutzen, während du dich im Tutorial befindest..',
    CANNOT_PICK_UP_ITEM: 'Dieser Gegenstand kann nur von {{username}} aufgehoben werden.',
    CANNOT_TALK: 'Du kannst jetzt nicht reden.',
    CANNOT_TRADE_ITEM: 'Du kannst diesen Gegenstand nicht handeln.',
    CANNOT_TRADE_CHEATER: 'Betrüger dürfen leider nicht handeln.',
    CANNOT_TRADE_CHEATER_OTHER:
        'Dieser Spieler ist ein Betrüger, er könnte dir Schmuggelware verkaufen!',
    CANNOT_TRADE_ADMIN: 'Als Administrator kannst du die Wirtschaft nicht beeinflussen.',
    CANNOT_TRADE_ADMIN_OTHER:
        'Der Spieler ist ein Administrator und kann nicht mit gehandelt werden.',
    DONT_THINK_GO_IN: 'Ich glaube nicht, dass ich da jetzt schon reingehen sollte...',
    ENTERED_LOBBY: 'Du hast die Lobby betreten für {{name}}.',
    EXITED_LOBBY: 'Du hast die Lobby verlassen für {{name}}.',
    IN_PVP_ZONE: 'Du hast eine PvP-Zone betreten!',
    INVALID_AMOUNT: 'Du hast einen ungültigen Betrag eingegeben.',
    DOOR_KEY_CRUMBLES: 'Der Schlüssel zerbröselt zu Staub, während du durch die Tür gehst.',
    MINIMUM_PLAYERS_MINIGAME:
        'Es müssen mindestens {{minimum}} Spieler anwesend sein, um dieses Minispiel zu starten.',
    NEED_COMBAT: 'Du musst im Kampf sein, um diese Fähigkeit zu nutzen.',
    NEED_WAIT_ABILIY:
        'Du musst {{duration}} Sekunden warten, bevor du diese Fähigkeit erneut einsetzen kannst.',
    NO_IDEA: 'Ich habe keine Ahnung, was das ist.',
    NO_ARROWS: 'Du hast keine Pfeile zum Schießen.',
    NO_ACHIEVEMENT_DOOR:
        'Du musst die Errungenschaft {{achievement}} abschließen, um durch diese Tür gehen zu können.',
    NO_COMBAT_DOOR:
        'Dein Kampflevel muss mindestens {{level}} sein, um durch diese Tür gehen zu können.',
    NO_QUEST_DOOR: 'Du musst die Quest {{quest}} abschließen, um durch diese Tür gehen zu können.',
    NO_KEY_DOOR: 'Du hast nicht den nötigen Schlüssel, um durch diese Tür gehen zu können.',
    NO_SKILL_DOOR:
        'Dein {{skill}} muss mindestens {{level}} sein, um durch diese Tür gehen zu können.',
    NO_KNOWLEDGE_USE: 'Du hast nicht das Wissen, um dies zu benutzen.',
    NO_SPACE: 'Du hast nicht genug Platz in deinem Inventar.',
    NO_SPACE_OTHER: 'Der andere Spieler hat nicht genug Platz in seinem Inventar.',
    NO_SPACE_PET: 'Du hast nicht genug Platz in deinem Haustierinventar.',
    NOT_IN_PVP_ZONE: 'Du bist nicht mehr in einer PvP-Zone!',
    NOT_ONLINE: 'Spieler @aquamarine@{{username}}@crimson@ ist nicht online.',
    NOT_ENOUGH_MANA: 'Du hast nicht genug Mana, um diese Fähigkeit einzusetzen.',
    PLEASE_MAKE_ROOM_REWARD: 'Bitte mach Platz in deinem Inventar, um diese Belohnung anzunehmen',
    POISONED: 'Du wurdest vergiftet!',
    POISON_WORN_OFF: 'Das Gift hat nachgelassen.',
    PLEASE_REPORT_BUG: 'Es ist ein Problem aufgetreten, bitte melde dies als Fehler.',
    FREEZE_IMMUNITY: 'Du bist jetzt für {{duration} Sekunden immun gegen Einfriereffekte.',
    FREEZE_IMMUNITY_WORN_OFF: 'Deine Immunität gegen Gefriereffekte hat nachgelassen.',
    FIRE_IMMUNITY: 'Du bist jetzt für {{duration}} Sekunden immun gegen Feuereffekte.',
    FIRE_IMMUNITY_WORN_OFF: 'Deine Immunität gegen Feuereffekte hat nachgelassen.',
    FRIENDS_USERNAME_TOO_LONG: 'Dieser Benutzername ist zu lang.',
    FRIENDS_ADD_SELF: `Hör zu, ich verstehe, dass du einsam bist. Du kannst dich aber nicht selber in deine Freundesliste eintragen.`,
    FRIENDS_ALREADY_ADDED: 'Dieser Spieler ist bereits in deiner Freundesliste.',
    FRIENDS_USER_DOES_NOT_EXIST: 'Es gibt keinen Spieler mit diesem Benutzernamen.',
    FRIENDS_NOT_IN_LIST: 'Dieser Spieler ist nicht in deiner Freundesliste.',
    PEOPLE_ONLINE: 'Derzeit sind {{population}} Spieler online.',
    SKILL_LEVEL_UP: 'Fertigkeitslevel erhöht!',
    SKILL_LEVEL_UP_DESC: 'Herzlichen Glückwunsch, dein {{name}} hat Level {{level}} erreicht!',
    JAILED: 'Du bist derzeit inhaftiert für {{duration}}.',
    MUTED: 'Du bist derzeit stummgeschaltet.',
    LOW_MANA: 'Du hast nur noch wenig Mana, deine Angriffe werden schwächer sein.',
    TRADE_REQUEST: 'Du hast angefragt, mit {{username}} zu handeln.',
    TRADE_REQUEST_OTHER: '{{username}} hat angefragt, mit dir zu handeln.',
    TRADE_EMPTY: `Yo, warum handelt ihr mit nichts??`,
    TRADE_COMPLETE: 'Danke, dass du das Kaetram Handelssystem benutzt!',
    WELCOME: 'Willkommen bei {{name}}!',
    WELCOME_BACK: 'Willkommen zurück bei {{name}}!',
    WHY_GO_THERE: 'Moment mal, warum sollte ich da reingehen??'
} as const;
